import axios, {AxiosResponse} from 'axios'
import {
  UnassignmentReason,
  UnassignmentReasonQueryResponse,
  UnassignmentReasonShort,
  ResponseObject,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const UNASSIGNMENT_REASON_URL = `${API_URL}/UnassignmentReason`

const getAllData = (query: string): Promise<UnassignmentReasonQueryResponse> => {
  return axios
    .get(`${UNASSIGNMENT_REASON_URL}?${query}`)
    .then((d: AxiosResponse<UnassignmentReasonQueryResponse>) => d.data)
}

const getById = (code: number): Promise<UnassignmentReason | undefined> => {
  return axios
    .get(`${UNASSIGNMENT_REASON_URL}/${code}`)
    .then((response: AxiosResponse<{data: UnassignmentReason}>) => response.data.data)
}

const getActive = (): Promise<UnassignmentReasonShort[]> => {
  return axios
    .get(`${UNASSIGNMENT_REASON_URL}/active`)
    .then((response: AxiosResponse<{data: UnassignmentReasonShort[]}>) => response.data.data)
}

const createDataRecord = (data: UnassignmentReason): Promise<ResponseObject | undefined> => {
  return axios
    .post(UNASSIGNMENT_REASON_URL, data)
    .then((response: AxiosResponse<ResponseObject>) => response.data)
}

const updateDataRecord = (data: UnassignmentReason): Promise<ResponseObject | undefined> => {
  return axios
    .put(UNASSIGNMENT_REASON_URL, data)
    .then((response: AxiosResponse<ResponseObject>) => response.data)
}

export {getAllData, getById, getActive, createDataRecord, updateDataRecord}
